import { createSelector } from 'reselect';
import { property } from 'underscore';

import { makeGetOutcomesByIds } from 'sportsbook-outcomes-selector';
import { sortByPrice, sortByPosition } from './sorters';

const isToday = (date) => {
  const now = new Date();
  return date.getDate() === now.getDate()
    && date.getMonth() === now.getMonth()
    && date.getFullYear() === now.getFullYear();
};

const withinTimeRange = (eventStartTime, timeRange) => (
  eventStartTime.getTime() < new Date().getTime() + timeRange * 1000
);

const convertToUtcTime = (time) => (
  time + new Date().getTimezoneOffset() * 60000
);

const withinStartEnd = (eventStartTime, startsAtTime, endsAtTime) => {
  const eventStartUtc = convertToUtcTime(eventStartTime);
  if (startsAtTime && endsAtTime) {
    return startsAtTime <= eventStartUtc && eventStartUtc <= endsAtTime;
  }
  if (startsAtTime) {
    return startsAtTime <= eventStartUtc;
  }
  if (endsAtTime) {
    return eventStartUtc <= endsAtTime;
  }
  return true; // return true if none of startsAt and endsAt is provided
};

const getEvents = (state, {
  namespacedStateEntry,
  filterTodayEvents,
  timeRange,
  startsAt,
  endsAt,
}) => {
  const { events } = state[namespacedStateEntry];
  const startsAtTime = startsAt ? new Date(startsAt).getTime() : 0;
  const endsAtTime = endsAt ? new Date(endsAt).getTime() : 0;

  if (filterTodayEvents || timeRange || startsAt || endsAt) {
    return events.filter(({ start_time: startTime }) => {
      const eventStartTime = new Date(startTime);

      return (filterTodayEvents ? isToday(eventStartTime) : true)
        && (timeRange ? withinTimeRange(eventStartTime, parseInt(timeRange, 10)) : true)
        && withinStartEnd(startTime, startsAtTime, endsAtTime);
    });
  }

  return events;
};

const getEventIds = (_, props) => props.eventIds;

export const makeGetEventsByIds = () => createSelector(
  [getEvents, getEventIds],
  (events, eventIds) => events.filter((event) => eventIds.includes(event.id)),
);

export const makeGetOutcomesIdsSortByPos = () => {
  const getOutcomesByIds = makeGetOutcomesByIds();

  return createSelector(
    [getOutcomesByIds],
    (outcomes) => (
      outcomes
        .sort(sortByPosition)
        .map(property('id'))
    ),
  );
};

const getNumberOfOutcomes = (_, props) => props.numberOfOutcomes;

export const makeGetOutcomesByIdsSortByPrice = () => {
  const getOutcomesByIds = makeGetOutcomesByIds();

  return createSelector(
    [getOutcomesByIds, getNumberOfOutcomes],
    (outcomes, numberOfOutcomes) => (
      outcomes
        .filter((o) => !o.h)
        .sort(sortByPrice)
        .slice(0, numberOfOutcomes)
        .map(property('id'))
    ),
  );
};
